const SURFACE_CUT_START_OFFSET_MIN = 1e-4;
const SURFACE_CUT_START_OFFSET_MAX = 1e-3;
const SURFACE_CUT_START_OFFSET_RATIO = 1e-4;
const SURFACE_CUT_START_OFFSET_DEPTH_FRACTION = 0.25;
const SURFACE_CUT_START_OFFSET_EXTENDED_RATIO = 0.05;
const SURFACE_CUT_START_OFFSET_STEP_RATIO = 0.001;

export interface SurfaceCutStartOffsetRange {
  default: number;
  min: number;
  max: number;
  step: number;
}

export function surfaceCutStartOffset(depth: number): number {
  const d = Math.abs(depth);
  if (!Number.isFinite(d) || d <= 0) return 0;
  const target = Math.min(
    SURFACE_CUT_START_OFFSET_MAX,
    Math.max(SURFACE_CUT_START_OFFSET_MIN, d * SURFACE_CUT_START_OFFSET_RATIO),
  );
  return Math.min(target, d * SURFACE_CUT_START_OFFSET_DEPTH_FRACTION);
}

export function surfaceCutStartOffsetRange(
  depth: number,
): SurfaceCutStartOffsetRange {
  const d = Math.abs(depth);
  const min = surfaceCutStartOffset(d);
  if (!Number.isFinite(d) || d <= 0 || min <= 0) {
    return {
      default: SURFACE_CUT_START_OFFSET_MIN,
      min: SURFACE_CUT_START_OFFSET_MIN,
      max: SURFACE_CUT_START_OFFSET_MAX,
      step: SURFACE_CUT_START_OFFSET_MIN,
    };
  }

  const depthCeiling = d * SURFACE_CUT_START_OFFSET_DEPTH_FRACTION;
  const extended = Math.max(min, d * SURFACE_CUT_START_OFFSET_EXTENDED_RATIO);
  const max = Math.max(min, Math.min(depthCeiling, extended));
  const step = Math.max(1e-6, d * SURFACE_CUT_START_OFFSET_STEP_RATIO);
  return { default: min, min, max, step };
}

export function clampSurfaceCutStartOffset(
  offset: number,
  depth: number,
): number {
  const range = surfaceCutStartOffsetRange(depth);
  const value = Number.isFinite(offset) ? offset : range.default;
  return Math.min(range.max, Math.max(range.min, value));
}
